import { Alert, Flex } from "antd";
import { useEffect } from "react";

import { ToastService } from "@shared/lib/services";

import { useAddInfluencerInitialCost } from "@entities/brief/lib/hooks/useAddInfluencerInitialCost";
// import { AddCommercials } from "./AddCommercials";

import { useAddInfluencerCost } from "@entities/brief/lib/hooks/useAddInfluencerCost";
import { useEditInfluencerCost } from "@entities/brief/lib/hooks/useEditInfluencerCost";
import { getInfoDetails } from "@entities/influencer/lib/utils/getInfoDetails";

import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import {
  IBriefInfluencerV2,
  IInfluencerCostRequest,
} from "@shared/lib/types/briefInfluencerV2";
import { AddCommercials } from "./AddCommercials";

interface InfluencerCommercialProps {
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  onClose: () => void;
  type: "view" | "create-new" | "create";
}

export function InfluencerCommercial({
  briefInfluencer,
  onClose,
  type,
}: InfluencerCommercialProps) {
  const isViewOnly = type === "view";

  const { briefId, brief } = useBriefStore();

  const creatorInfo = getInfoDetails(briefInfluencer as IBriefInfluencerV2);

  const { addInitialCost, isAdded, isAdding } =
    useAddInfluencerInitialCost(briefId);
  const {
    addCost,
    isAdded: isAddedCost,
    isAdding: isAddingCost,
  } = useAddInfluencerCost(briefId);

  const { editCost, isEditing, isEdited } = useEditInfluencerCost(briefId);

  const handleSaveCommercials = (
    values: Omit<IInfluencerCostRequest, "briefInfluencerId">
  ) => {
    if (isViewOnly) {
      return editCost({
        ...values,
        briefInfluencerId: briefInfluencer._id,
      });
    }
    if (type === "create-new") {
      addCost({
        ...values,
        briefInfluencerId: briefInfluencer._id,
      });
    } else {
      addInitialCost({
        ...values,
        briefInfluencerId: briefInfluencer._id,
      });
    }
  };

  useEffect(() => {
    if (isAdded) {
      ToastService.success("Initial cost added successfully");
      onClose();
    }
    if (isAddedCost) {
      ToastService.success("Cost added successfully");
      onClose();
    }
    if (isEdited) {
      ToastService.success("Cost updated successfully");
      onClose();
    }
  }, [isAdded, isAddedCost, isEdited]);

  const isPricingPocAssigned = Boolean(
    briefInfluencer.assignedPricingPocV2?.assignedToUserId
  );

  return (
    <Flex vertical gap={24} style={{ width: 200 }}>
      {!isPricingPocAssigned ? (
        <Alert
          message="Pricing POC not assigned. Please assign a Pricing POC to continue."
          type="warning"
          showIcon
        />
      ) : null}
      <AddCommercials
        isViewOnly={isViewOnly}
        type="influencer"
        briefInfluencer={briefInfluencer}
        initialValues={{
          cost: briefInfluencer.influencerCost?.cost,
          note: briefInfluencer?.influencerCost?.note,
        }}
        onClose={onClose}
        isLoading={isAdding || isAddingCost || isEditing}
        handleSave={handleSaveCommercials}
      />
    </Flex>
  );
}
